import { NewHireJourney } from "models/v2/newHireJourney";
import { Task } from "features/Resources/Task/models";
import TasksView from "features/Resources/Task/Components/TasksView";

interface TasksTabProps {
  newHireJourney: NewHireJourney;
  allTasks?: Task[];
  myTasks?: Task[];
  managerTasks?: Task[];
  newHireTasks?: Task[];
  teamTasks?: Task[];
}

export default function TasksTab({
  newHireJourney,
  allTasks = [],
  myTasks = [],
  managerTasks = [],
  newHireTasks = [],
  teamTasks = [],
}: TasksTabProps) {
  return (
    <TasksView
      newHireJourney={newHireJourney}
      allTasks={allTasks}
      myTasks={myTasks}
      managerTasks={managerTasks}
      newHireTasks={newHireTasks}
      teamTasks={teamTasks}
    />
  );
}
